export default __webpack_public_path__ + "static/media/sneh.ffe1efe4.png";